import spinner from "../assets/img/spinner.gif";
import { TMessage } from "../i18n/tt";

import { useTranslation } from "../stores/RootStoreContext";

export function LoadingOverlay({ message }: { message?: TMessage }) {
  const { t } = useTranslation();
  const alt: TMessage = message ? message : { key: "loading" };
  return (
    <div
      className={
        "tw-absolute tw-inset-0 bg-default-dimmed50 tw-z-10 tw-h-full tw-w-full tw-justify-center tw-flex tw-items-center"
      }
    >
      <img src={spinner} alt={t(alt)} width={80} />
    </div>
  );
}
